/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function() {
  // Add custom code below this line
  document.querySelector('button.cart__checkout.btn--solid').onclick = function(e){
    e.preventDefault();
    var sets, diamonds;
    if (this.closest('.drawer__inner')){
      sets = [...this.closest('.drawer__inner').querySelectorAll('div.cart__item.ring-setting')];
      diamonds = [...this.closest('.drawer__inner').querySelectorAll('div.cart__item.loose-diamond')];
    } else {
      sets = [...this.closest('.cart__inner').querySelectorAll('div.cart__item.ring-setting')];
      diamonds = [...this.closest('.cart__inner').querySelectorAll('div.cart__item.loose-diamond')];
    }
    if (sets.length > 0){
      var toFind = sets.length;
      sets.forEach(set=>{diamonds.forEach(stone=>{if (set.getAttribute('shape').includes(stone.getAttribute('shape'))){toFind -= 1;}});});
      if (toFind > 0){
        document.querySelector('div.popup').classList.add('open');
      } else {
        window.location.href = '/checkout';
      }
    } else {
      window.location.href = '/checkout';
    }
  }
  document.querySelector('div.popup').onclick = function(e){if (e.target == this || e.target.tagName == 'B'){this.classList.remove('open');}}

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
